import React from "react";
import Overlay from "../../../components/overlay";

export default function() {
  const { forms = [], loading } = this.state;
  return (
    <div>
      <label>Inspection History</label>
      {loading && <Overlay />}
      {forms.length === 0 && (
        <div className="placeholder">
          {navigator.onLine ? "No previous reports" : "Cant retreive reports"}
        </div>
      )}
      {forms.map((form, key) => this._renderForm(form, key))}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/screens/machines/tool-history/view.js